"use client";

import React, { useState } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useRouter } from "@/i18n/routing";
type Props = {
  options: Array<{ value: string; label: string }>;
  current: string;
  ariaLabel: string;
};

const HomeCitiesSelect: React.FC<Props> = ({
  options,
  current,
  ariaLabel,
}) => {
  const [selected, setSelected] = useState(current);
  const router = useRouter();
  return (
    <Select
      value={selected || current}
      onValueChange={(e) => {
        setSelected(e);
        router.replace(
          {
            pathname: "/",
            query: {
              city: e,
            },
          },
          {
            scroll: false,
          },
        );
      }}
    >
      <SelectTrigger
        aria-label={ariaLabel}
        className="h-11 w-48 rounded-xl text-xl font-semibold tracking-tight sm:h-12 sm:w-56 sm:text-2xl"
      >
        <div className="flex flex-row items-center gap-2">
          <SelectValue
            placeholder={
              options.find((option) => option.value === current)?.label ??
              current
            }
          />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default HomeCitiesSelect;
